import { useEffect } from "react";

export const useKeyboardShortcuts = (shortcuts) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check for Cmd (Mac) or Ctrl (Windows/Linux)
      const isModifierPressed = event.metaKey || event.ctrlKey;
      
      if (!isModifierPressed) return;

      const key = event.key.toLowerCase();
      const shortcut = shortcuts.find((s) => s.key === key);

      if (shortcut) {
        event.preventDefault();
        shortcut.action();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [shortcuts]);
};

// Common shortcuts
export const SHORTCUTS = {
  NEW_CHAT: { key: "k", description: "New chat" },
  SEARCH: { key: "f", description: "Search" },
  SETTINGS: { key: ",", description: "Settings" },
};








